const providerHomeConfig = {
  view: "providerHome",
}

export default providerHomeConfig
